import { useState, useEffect } from "react";
import { characters } from "utilities/characters";

export interface CharacterInputState {
  currentPosition: number;
  setCurrentPosition: React.Dispatch<React.SetStateAction<number>>;
  input: string[];
  setInput: React.Dispatch<React.SetStateAction<string[]>>;
  index: number;
  setIndex: React.Dispatch<React.SetStateAction<number>>;
}

interface UseCharacterInputProps {
  initialInput: string[];
  maxLength: number;
  initialPosition?: number;
}

export default function useCharacterInput({
  initialInput,
  maxLength,
  initialPosition = 5,
}: UseCharacterInputProps): CharacterInputState {
  const [currentPosition, setCurrentPosition] = useState(initialPosition);
  const [input, setInput] = useState<string[]>(initialInput);
  const [index, setIndex] = useState(0);

  useEffect(() => {
    setInput(initialInput);
    if (initialInput.length === maxLength && !initialInput.includes("")) {
      setCurrentPosition(characters.findIndex((c) => c === "complete"));
    }
  }, [initialInput, maxLength]);

  return {
    currentPosition,
    setCurrentPosition,
    input,
    setInput,
    index,
    setIndex,
  };
}
